var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"headerTop"},[_c('header-top',{staticClass:"headerTopCon"})],1),_c('div',{staticClass:"mainContent"},[_c('router-view')],1),_c('footer',{staticClass:"footerBottom"},[_c('footer-bottom')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }